import { styled } from "../../../../../../../styles";

export const SummaryContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const QuestionText = styled("p", {
  margin: 0,
  fontFamily: "$openSans",
  fontSize: "15px",
  fontWeight: 600,
  color: "$charcoal",
});

export const OptionList = styled("ul", {
  margin: 0,
  padding: 0,
  listStyle: "none",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

/** Label and (if any) jump target, one option per line; values are in the editor. */
export const OptionRow = styled("li", {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) max-content",
  alignItems: "center",
  columnGap: "16px",
  padding: "8px 12px",
  borderRadius: "6px",
  backgroundColor: "$white",
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",
});

export const OptionValue = styled("span", {
  color: "$gray-100",
  fontSize: "13px",
});

export const InfoText = styled("div", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",

  p: { margin: 0, minHeight: "1em" },
  img: { maxWidth: "100%" },
});
